export function URLSafeParse(urlstring): URL | false {
    try {
        return new URL(urlstring);
    } catch (error) {
        return false;
    }
}
